
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M280.094118 554.164706l66.258823 63.247059-117.458823 120.470588c-18.070588 18.070588-18.070588 45.176471-3.011765 63.247059 27.105882 27.105882 63.247059-3.011765 63.247059-3.011765l117.458823-120.470588 63.247059 63.247059c15.058824 15.058824 42.164706 15.058824 42.164706-18.070589v-210.823529H298.164706c-15.058824 0-27.105882 9.035294-27.105882 21.082353 0 9.035294 3.011765 15.058824 9.035294 21.082353z m518.023529-331.294118c-27.105882-27.105882-63.247059 3.011765-63.247059 3.011765l-117.458823 120.470588-63.247059-63.247059c-12.047059-15.058824-42.164706-15.058824-42.164706 18.070589v210.823529h213.835294c12.047059 0 24.094118-9.035294 27.105882-21.082353 0-9.035294-3.011765-15.058824-9.035294-21.082353l-66.258823-63.247059 117.458823-120.470588c21.082353-18.070588 21.082353-45.176471 3.011765-63.247059z"
      }
    }
  ]
})
    }
  